export const BODY_INJURY = 'Body Injury';
export const PROPERTY_DAMAGE = 'Property Damage';
export const UN_UIN_MOTORIST = 'Uninsured/Underinsured Motorist';
export const MEDICAL_PAYMENT = 'Medical Payments';
export const ADD_VEHICLE = 'Add Vehicle';
export const ADD_DRIVER = 'Add Driver';
export const VEHICLES = 'Vehicles';
export const DRIVERS = 'Drivers';
